/**
 * 2024-05-01T00:00:00+09:00
 * などの形式を読み込む。
 *
 * Localeの情報はあえて利用しないようにするために、正規表現を利用して文字列を取得するようにしている
 * */
const decodeYMD = ({
  time,
}: { time: string }): { year: string; month: string; day: string; hour: string; minute: string } => {
  const match = time.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/)
  if (match) {
    const year = match[1]
    const month = match[2]
    const day = match[3]
    const hour = match[4]
    const minute = match[5]
    //console.log(`年: ${year}, 月: ${month}, 日: ${day}`)
    // 出力: 年: 2024, 月: 05, 日: 01
    return { year, month, day, hour, minute }
  }
  return { year: '', month: '', day: '', hour: '', minute: '' }
}

export function time({ time, language }: { time: string; language: string }) {
  if (time === '' || !time) return
  const { year, month, day } = decodeYMD({ time })
  //const datetime = new Date(time)
  const jpDate = `${year}年${month}月${day}日`
  const enDate = `${month}/${day}/${year}`
  if (language === 'en_US' || language === 'en') return enDate
  // シンガポールは英国式の日/月/年（#3601）
  if (language === 'en_SG') return `${day}/${month}/${year}`
  if (language === 'ko_KR') return `${year}년${month}월${day}일`
  if (language === 'zh_TW') return `民國${Number.parseInt(year) - 1911}年${month}月${day}日`
  // zh_CH は日本と変わらなさそうなため jpDate
  return jpDate
}

/**
 * 2026-09-14T12:00:00+09:00 のような ISO 8601 文字列を「日付 + 時刻（HH:mm）」に整形する（#3635）。
 * 日付はスラッシュ区切りの数字だけにする（time() の「年月日」表記とは別）。
 * - en_US / en: MM/DD/YYYY、en_SG: DD/MM/YYYY（英国式）、それ以外: YYYY/MM/DD
 * - 時刻は 24 時間表記で全言語共通
 * タイムゾーン変換はしない（API が返す JST の値をそのまま表示する）。読めない文字列は undefined。
 */
export function dateTime({ time: iso, language }: { time: string; language: string }): string | undefined {
  if (iso === '' || !iso) return
  const { year, month, day, hour, minute } = decodeYMD({ time: iso })
  if (!year) return
  const date =
    language === 'en_US' || language === 'en'
      ? `${month}/${day}/${year}`
      : language === 'en_SG'
        ? `${day}/${month}/${year}`
        : `${year}/${month}/${day}`
  return `${date} ${hour}:${minute}`
}
